var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.904 21.367H2.302v-10.68H0V7.003h2.3v-2.21c0-3.002 1.3-4.79 4.988-4.79h3.071v3.683H8.442c-1.438 0-1.532.515-1.532 1.476l-.006 1.841h3.479l-.408 3.682H6.904v10.681z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "img/_/_/views/utils/components/Footer/assets/svg/facebook-white.svg";
export { SvgFacebookWhite as ReactComponent };